/*
  LAMIXO quick add (21 Oct 2026) - Temu-style add to cart from product cards.

  - Every product card gets a working round cart button: the existing icon on
    category cards (.lmx-card .lmx-cart) and an injected one on the home rails
    (a.c inside [id^="lmxr-"]).
  - The button opens a pop-up built from /products/<handle>.js: gallery,
    price / was / % off, colour swatches (variant photos), size pills (sold-out
    crossed out), quantity and the orange button ("Select an option" until
    every option is chosen). Quantity, add and + never go past the stock
    (sections/lamixo-stock); a note under the button says why.
  - Add -> /cart/add.js, then: button turns into "- 1 Added +" stepper
    (/cart/change.js), "Added to cart" toast, product image flies to the bag
    icon, bag badge bumps, mini-cart panel slides in (subtotal, free-shipping
    progress to AED 200, Go to cart, items).
  Styles: assets/lamixo-quick-add.css.
*/
(function () {
  if (window.__lmxQA) return;
  window.__lmxQA = 1;

  var FREE_SHIP = 20000; /* AED 200 in fils */
  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h7.7a1.6 1.6 0 0 0 1.6-1.2L20 8H6.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 9.5v4M11 11.5h4" stroke-linecap="round"/><circle cx="10" cy="20" r="1.3" fill="currentColor" stroke="none"/><circle cx="17" cy="20" r="1.3" fill="currentColor" stroke="none"/></svg>';
  var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke-linecap="round"/></svg>';

  function money(cents) {
    var v = (Number(cents || 0) / 100).toFixed(2);
    return 'AED' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(src, w) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }
  function handleFrom(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function isColor(name) { return /colou?r|颜色|اللون/i.test(name || ''); }

  /* ---------- cart helpers ---------- */
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function setBadge(count) {
    var a = document.querySelector('.lmxh a[href="/cart"], .lmxh a[href$="/cart"]');
    if (!a) return;
    var b = a.querySelector('b');
    if (!b) { b = document.createElement('b'); a.appendChild(b); }
    b.textContent = count;
    b.style.display = count > 0 ? '' : 'none';
    b.classList.remove('lmxqa-bump'); void b.offsetWidth; b.classList.add('lmxqa-bump');
  }

  function announce(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'lmxqa', data: { source: 'lmxqa', itemCount: cart.item_count } }
      }));
    } catch (e) {}
  }

  var MINUS_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var PLUS_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M8 3v10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var cartNow = null;   /* last cart seen, so a variant already in the cart shows its stepper */

  /* ---------- stock limits ----------
     { variantId: units in stock | null (not limited) } from sections/lamixo-stock */
  var stockCache = {};
  function stockFor(handle) {
    if (!handle) return Promise.resolve({});
    if (!stockCache[handle]) {
      stockCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=lamixo-stock', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var m = t.match(/<script[^>]*lmx-stock[^>]*>([\s\S]*?)<\/script>/);
          try { return m ? JSON.parse(m[1]) : {}; } catch (e) { return {}; }
        })
        .catch(function () { return {}; });
    }
    return stockCache[handle];
  }
  function inCart(vid) {
    if (!cartNow) return 0;
    return cartNow.items.reduce(function (n, it) { return n + (it.variant_id === vid ? it.quantity : 0); }, 0);
  }
  function stockOf(map, vid) { var s = map && map[vid]; return typeof s === 'number' ? s : null; }
  /* how many more of this variant can still go in the cart */
  function roomFor(map, vid) {
    var s = stockOf(map, vid);
    return s == null ? Infinity : Math.max(0, s - inCart(vid));
  }
  function stockNote(s, have, kind) {
    var left = 'Only ' + s + ' left in stock';
    if (kind === 'full') return have >= s
      ? 'You already have all ' + s + ' in your cart — that’s all we have in stock.'
      : left + '.';
    if (kind === 'capped') return left + (have ? ' (' + have + ' already in your cart)' : '') + '. Quantity set to the maximum you can add.';
    if (kind === 'added') return left + ', so we added the last ' + (s - have > 0 ? s - have : s) + ' for you.';
    return left + '.';
  }

  /* ---------- mini-cart panel ----------
     Desktop: stays open beside the page and pushes the page left (like
     Temu) instead of covering it. It stays open on every page (localStorage
     flag) until the shopper presses x. Each item has a delete button.
     Mobile: bottom sheet. */
  var rail, railTimer, RAIL_KEY = 'lmxRailOpen';
  function railFlag(on) {
    try {
      if (on === undefined) return localStorage.getItem(RAIL_KEY) === '1';
      if (on) localStorage.setItem(RAIL_KEY, '1'); else localStorage.removeItem(RAIL_KEY);
    } catch (e) {}
    return false;
  }
  var TRASH_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function railRemove(btn) {
    var it = btn.closest('.lmxqa-it'), key = it && it.getAttribute('data-key');
    if (!key || it.classList.contains('is-busy')) return;
    it.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) { setBadge(cart.item_count); renderRail(cart); announce(cart); })
      .catch(function () { it.classList.remove('is-busy'); });
  }
  function renderRail(cart, newKey, instant) {
    cartNow = cart;
    if (!cart.item_count) { closeRail(true); return; }
    if (!rail) {
      rail = document.createElement('aside');
      rail.className = 'lmxqa-rail';
      rail.setAttribute('aria-label', 'Cart summary');
      document.body.appendChild(rail);
      rail.addEventListener('click', function (e) {
        if (e.target.closest('.x')) { closeRail(true); return; }
        var del = e.target.closest('.lmxqa-del');
        if (del) { e.preventDefault(); railRemove(del); }
      });
    }
    var left = FREE_SHIP - cart.total_price;
    var pct = Math.max(4, Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100)));
    var items = cart.items.map(function (it) {
      return '<div class="lmxqa-it' + (it.key === newKey ? ' is-new' : '') + '" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' +
        '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">' +
        '<div><b>' + money(it.final_line_price) + '</b><span>' + esc(it.variant_title || '') + '</span><span>Qty ' + it.quantity + '</span></div></a>' +
        '<button type="button" class="lmxqa-del" aria-label="Remove ' + esc(it.product_title || 'item') + '">' + TRASH_SVG + '</button></div>';
    }).join('');
    rail.innerHTML =
      '<div class="lmxqa-rail-h">' +
        '<button class="x" type="button" aria-label="Close">&times;</button>' +
        '<div class="lmxqa-sub">' + CART_SVG.replace('<svg', '<svg width="16" height="16"') + 'Subtotal</div>' +
        '<div class="lmxqa-subv">' + money(cart.total_price) + '</div>' +
        (left > 0
          ? '<p class="lmxqa-ship">Add <b>' + money(left) + '</b> more for <b>free shipping</b></p>'
          : '<p class="lmxqa-ship is-free">✓ You’ve unlocked free shipping</p>') +
        '<div class="lmxqa-bar"><i style="width:' + (left > 0 ? pct : 100) + '%"></i></div>' +
        '<a class="lmxqa-go" href="/cart">Go to cart (' + cart.item_count + ')</a>' +
      '</div>' +
      '<div class="lmxqa-items">' + items + '</div>';
    railFlag(true);
    var html = document.documentElement;
    if (instant) {
      html.classList.add('lmxqa-instant');
      rail.classList.add('is-open'); html.classList.add('lmxqa-push');
      setTimeout(function () { html.classList.remove('lmxqa-instant'); }, 60);
    } else {
      requestAnimationFrame(function () { rail.classList.add('is-open'); html.classList.add('lmxqa-push'); });
    }
    clearTimeout(railTimer);
    if (window.matchMedia('(max-width: 749px)').matches) railTimer = setTimeout(function () { closeRail(); }, 9000);
  }
  /* byUser: x pressed or cart emptied -> stays closed on the next pages too */
  function closeRail(byUser) {
    if (rail) rail.classList.remove('is-open');
    document.documentElement.classList.remove('lmxqa-push');
    if (byUser) railFlag(false);
  }
  /* reopen on the next page if the shopper had not closed it (desktop, not on cart/checkout) */
  function restoreRail() {
    if (!railFlag()) return;
    if (/^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    getCart().then(function (c) {
      if (c && c.item_count) renderRail(c, null, true); else closeRail(true);
    }).catch(function () {});
  }

  /* ---------- fly to bag ---------- */
  function fly(fromImg) {
    var bag = document.querySelector('.lmxh a[href="/cart"], .lmxh a[href$="/cart"]');
    if (!fromImg || !bag || !fromImg.getBoundingClientRect) return;
    var a = fromImg.getBoundingClientRect(), b = bag.getBoundingClientRect();
    if (!a.width || b.bottom < 0) return;
    var c = document.createElement('img');
    c.className = 'lmxqa-fly';
    c.src = fromImg.currentSrc || fromImg.src;
    var s = Math.min(a.width, 140);
    c.style.width = s + 'px'; c.style.height = s + 'px';
    c.style.left = (a.left + a.width / 2 - s / 2) + 'px';
    c.style.top = (a.top + a.height / 2 - s / 2) + 'px';
    document.body.appendChild(c);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        c.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)';
        c.style.opacity = '.3';
      });
    });
    setTimeout(function () { c.remove(); }, 800);
  }

  /* ---------- pop-up ---------- */
  var ov, lastFocus;

  function close() {
    if (!ov) return;
    ov.remove(); ov = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function open(handle, url) {
    lastFocus = document.activeElement;
    close();
    ov = document.createElement('div');
    ov.className = 'lmxqa-ov';
    ov.innerHTML = '<div class="lmxqa-dlg" role="dialog" aria-modal="true" aria-label="Choose options"><button class="lmxqa-x" type="button" aria-label="Close">' + X_SVG + '</button><p style="grid-column:1/-1;margin:40px 0;text-align:center;color:#888">Loading…</p></div>';
    document.body.appendChild(ov);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('.lmxqa-x')) close();
    });
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { if (ov) build(p, url); })
      .catch(function () { close(); location.href = url; });
  }

  function build(p, url) {
    var dlg = ov.querySelector('.lmxqa-dlg');
    var options = (p.options || []).map(function (o, i) {
      return typeof o === 'string'
        ? { name: o, values: uniq(p.variants.map(function (v) { return v['option' + (i + 1)]; })) }
        : { name: o.name, values: o.values };
    }).filter(function (o) { return !(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title'); });

    var sel = [];
    options.forEach(function (o, i) {
      if (o.values.length === 1) sel[i] = o.values[0];
      else if (isColor(o.name)) {
        var firstAvail = p.variants.filter(function (v) { return v.available; })[0];
        sel[i] = firstAvail ? firstAvail['option' + (i + 1)] : null;
      }
    });

    var images = (p.images || []).slice(0, 12);
    var qty = 1, lineKey = null, lineQty = 0, busy = false, stock = null;

    dlg.innerHTML =
      '<button class="lmxqa-x" type="button" aria-label="Close">' + X_SVG + '</button>' +
      '<div class="lmxqa-gal">' +
        '<img class="lmxqa-main" alt="' + esc(p.title) + '" src="' + esc(img(images[0] || p.featured_image, 800)) + '">' +
        '<div class="lmxqa-thumbs">' + images.map(function (s, i) {
          return '<button type="button" data-i="' + i + '"' + (i === 0 ? ' class="is-on"' : '') + ' aria-label="Image ' + (i + 1) + '"><img src="' + esc(img(s, 120)) + '" alt="" loading="lazy"></button>';
        }).join('') + '</div>' +
      '</div>' +
      '<div class="lmxqa-info">' +
        '<h3 class="lmxqa-title">' + esc(p.title) + '</h3>' +
        '<div class="lmxqa-price"></div>' +
        options.map(function (o, i) {
          return '<div class="lmxqa-opt" data-o="' + i + '"><h4>' + esc(o.name) + ': <span class="lmxqa-cur"></span></h4><div class="lmxqa-vals">' +
            o.values.map(function (v) {
              if (isColor(o.name)) {
                var vv = p.variants.filter(function (x) { return x['option' + (i + 1)] === v && x.featured_image; })[0];
                var src = vv ? vv.featured_image.src : null;
                if (src) return '<button type="button" class="lmxqa-sw" data-v="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '"><img src="' + esc(img(src, 120)) + '" alt=""></button>';
              }
              return '<button type="button" class="lmxqa-pill" data-v="' + esc(v) + '">' + esc(v) + '</button>';
            }).join('') + '</div></div>';
        }).join('') +
        '<div class="lmxqa-qty">Qty <div class="lmxqa-step"><button type="button" data-q="-1" aria-label="Decrease">' + MINUS_SVG + '</button><span>1</span><button type="button" data-q="1" aria-label="Increase">' + PLUS_SVG + '</button></div></div>' +
        '<div class="lmxqa-ctas">' +
          '<button type="button" class="lmxqa-cta"></button>' +
          '<div class="lmxqa-added" aria-live="polite"><button type="button" data-l="-1" aria-label="Remove one">' + MINUS_SVG + '</button><div><b></b><small></small></div><button type="button" data-l="1" aria-label="Add one">' + PLUS_SVG + '</button></div>' +
        '</div>' +
        '<p class="lmxqa-err" hidden></p>' +
        '<a class="lmxqa-more" href="' + esc(url) + '">All details ›</a>' +
      '</div>';

    var main = dlg.querySelector('.lmxqa-main');
    var cta = dlg.querySelector('.lmxqa-cta');
    var added = dlg.querySelector('.lmxqa-added');
    var err = dlg.querySelector('.lmxqa-err');

    function current() {
      if (options.length === 0) return p.variants[0];
      for (var i = 0; i < options.length; i++) if (sel[i] == null) return null;
      return p.variants.filter(function (v) {
        return options.every(function (o, i) { return v['option' + (i + 1)] === sel[i]; });
      })[0] || null;
    }
    function availableWith(i, val) {
      return p.variants.some(function (v) {
        if (!v.available || v['option' + (i + 1)] !== val) return false;
        return options.every(function (o, j) { return j === i || sel[j] == null || v['option' + (j + 1)] === sel[j]; });
      });
    }

    function render() {
      var v = current();
      var ref = v || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var price = ref.price, was = ref.compare_at_price;
      var off = was && was > price ? Math.round((1 - price / was) * 100) : 0;
      dlg.querySelector('.lmxqa-price').innerHTML =
        '<span class="lmxqa-now">' + money(price) + '</span>' +
        (off ? '<span class="lmxqa-was">' + money(was) + '</span><span class="lmxqa-off">-' + off + '%</span>' : '');

      options.forEach(function (o, i) {
        var box = dlg.querySelector('.lmxqa-opt[data-o="' + i + '"]');
        box.querySelector('.lmxqa-cur').textContent = sel[i] || '';
        box.querySelectorAll('[data-v]').forEach(function (b) {
          var val = b.getAttribute('data-v');
          b.classList.toggle('is-on', val === sel[i]);
          b.classList.toggle('is-out', !availableWith(i, val));
          b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
        });
      });

      if (v && v.featured_image) {
        main.src = img(v.featured_image.src, 800);
        dlg.querySelectorAll('.lmxqa-thumbs button').forEach(function (t) { t.classList.remove('is-on'); });
      }

      cta.classList.remove('is-wait', 'is-out');
      if (!v) {
        cta.textContent = 'Select an option';
        cta.classList.add('is-wait');
      } else if (!v.available) {
        cta.textContent = 'Sold out';
        cta.classList.add('is-out');
      } else if (v.compare_at_price && v.compare_at_price > v.price) {
        cta.textContent = money((v.compare_at_price - v.price) * qty) + ' OFF! ADD NOW!';
      } else {
        cta.textContent = 'Add to cart · ' + money(v.price * qty);
      }
      showAdded(false);
      var line = v && cartNow && cartNow.items.filter(function (it) { return it.variant_id === v.id; })[0];
      if (line) { lineKey = line.key; lineQty = line.quantity; showAdded(true, v); }
    }

    function showAdded(on, v) {
      if (!on) { added.classList.remove('is-on'); cta.style.display = ''; return; }
      added.querySelector('b').textContent = lineQty + ' Added';
      added.querySelector('small').textContent = (v && v.title && v.title !== 'Default Title') ? v.title : '';
      cta.style.display = 'none';
      added.classList.add('is-on');
    }

    function toast() {
      var t = document.createElement('div');
      t.className = 'lmxqa-toast';
      t.innerHTML = '<i>✓</i>Added to cart';
      dlg.querySelector('.lmxqa-gal').appendChild(t);
      setTimeout(function () { t.remove(); }, 1900);
    }

    function showErr(msg, warn) {
      err.textContent = msg; err.hidden = !msg;
      err.classList.toggle('is-warn', !!warn);
    }
    function setQty(n) {
      qty = Math.max(1, Math.min(99, n));
      dlg.querySelector('.lmxqa-step span').textContent = qty;
      dlg.querySelector('[data-q="-1"]').disabled = qty <= 1;
    }
    /* keep the quantity inside what is left in stock; true if it had to be lowered */
    function clampQty(v) {
      var room = v ? roomFor(stock, v.id) : Infinity;
      if (room !== Infinity && qty > Math.max(1, room)) { setQty(Math.max(1, room)); return true; }
      return false;
    }

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      var th = t.closest('.lmxqa-thumbs button');
      if (th) {
        main.src = img(images[+th.getAttribute('data-i')], 800);
        dlg.querySelectorAll('.lmxqa-thumbs button').forEach(function (b) { b.classList.toggle('is-on', b === th); });
        return;
      }
      var vb = t.closest('[data-v]');
      if (vb) {
        var i = +vb.closest('.lmxqa-opt').getAttribute('data-o');
        sel[i] = vb.getAttribute('data-v');
        vb.closest('.lmxqa-opt').classList.remove('is-missing');
        lineKey = null; lineQty = 0; showErr('');
        render();
        var cv = current();
        if (cv && clampQty(cv)) { render(); showErr(stockNote(stockOf(stock, cv.id), inCart(cv.id), 'capped'), true); }
        return;
      }
      var qb = t.closest('[data-q]');
      if (qb) {
        var d = +qb.getAttribute('data-q'), v0 = current();
        showErr('');
        if (d > 0 && v0) {
          var room = roomFor(stock, v0.id), s0 = stockOf(stock, v0.id);
          if (room !== Infinity && qty + 1 > room) {
            setQty(Math.max(1, room));
            showErr(room <= 0 ? stockNote(s0, inCart(v0.id), 'full') : stockNote(s0, inCart(v0.id), 'capped'), true);
            render();
            return;
          }
        }
        setQty(qty + d);
        render();
        return;
      }
      if (t.closest('.lmxqa-cta')) { add(); return; }
      var lb = t.closest('[data-l]');
      if (lb) { change(+lb.getAttribute('data-l')); }
    });

    function add() {
      var v = current();
      if (!v) {
        options.forEach(function (o, i) {
          if (sel[i] == null) {
            var box = dlg.querySelector('.lmxqa-opt[data-o="' + i + '"]');
            box.classList.remove('is-missing'); void box.offsetWidth; box.classList.add('is-missing');
          }
        });
        return;
      }
      if (!v.available || busy) return;
      showErr('');
      var room = roomFor(stock, v.id), s1 = stockOf(stock, v.id), capped = false;
      if (room <= 0) { showErr(stockNote(s1, inCart(v.id), 'full'), true); return; }
      if (qty > room) { setQty(room); capped = true; }
      busy = true;
      cta.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (res) {
          var item = (res.items && res.items[0]) || res;
          lineKey = item.key; lineQty = item.quantity;
          fly(main);
          toast();
          showAdded(true, v);
          if (capped) showErr('Only ' + s1 + ' left in stock, so we added the maximum you can (' + qty + ').', true);
          return getCart().then(function (cart) {
            setBadge(cart.item_count);
            renderRail(cart, lineKey);
            announce(cart);
          });
        })
        .catch(function (e) {
          render();
          showErr((e && (e.description || e.message)) || 'Could not add to cart. Please try again.');
        })
        .then(function () { busy = false; });
    }

    function change(delta) {
      if (!lineKey || busy) return;
      showErr('');
      var cv = current(), sc = cv ? stockOf(stock, cv.id) : null;
      if (delta > 0 && sc != null && lineQty >= sc) {
        showErr('Only ' + sc + ' left in stock — you already have all of them in your cart.', true);
        return;
      }
      busy = true;
      var next = Math.max(0, lineQty + delta);
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: next })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (cart) {
          var line = cart.items.filter(function (it) { return it.key === lineKey; })[0];
          lineQty = line ? line.quantity : 0;
          setBadge(cart.item_count);
          cartNow = cart;
          if (lineQty > 0) { showAdded(true, current()); renderRail(cart, lineKey); }
          else { lineKey = null; render(); renderRail(cart); }
          announce(cart);
        })
        .catch(function (e) { showErr((e && (e.description || e.message)) || 'Could not update the cart.'); })
        .then(function () { busy = false; });
    }

    render();
    setQty(1);
    getCart().then(function (c) { cartNow = c; if (!busy && !lineKey) render(); }).catch(function () {});
    stockFor(p.handle).then(function (m) { stock = m; });
    var first = dlg.querySelector('.lmxqa-x');
    if (first) first.focus({ preventScroll: true });
  }

  function uniq(a) { return a.filter(function (v, i) { return v != null && a.indexOf(v) === i; }); }

  /* ---------- wire up cards ---------- */
  function decorate(root) {
    (root || document).querySelectorAll('[id^="lmxr-"] a.c').forEach(function (a) {
      if (a.querySelector('.lmxqa-cardbtn')) return;
      var pr = a.querySelector('.pr');
      if (!pr) return;
      var b = document.createElement('span');
      b.className = 'lmxqa-cardbtn';
      b.setAttribute('role', 'button');
      b.setAttribute('aria-label', 'Add to cart');
      b.innerHTML = CART_SVG;
      pr.classList.add('lmxqa-hasbtn');
      pr.appendChild(b);
    });
    (root || document).querySelectorAll('.lmx-card .lmx-cart').forEach(function (s) {
      if (s.dataset.lmxqa) return;
      s.dataset.lmxqa = '1';
      s.removeAttribute('aria-hidden');
      s.setAttribute('role', 'button');
      s.setAttribute('aria-label', 'Add to cart');
      s.setAttribute('tabindex', '0');
    });
  }

  function trigger(e) {
    var btn = e.target.closest && e.target.closest('.lmxqa-cardbtn, .lmx-card .lmx-cart');
    if (!btn) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var a = btn.closest('a[href*="/products/"]');
    var h = a && handleFrom(a.getAttribute('href'));
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    open(h, a.getAttribute('href'));
  }
  document.addEventListener('click', trigger, true);
  document.addEventListener('keydown', trigger, true);

  /* ---------- shared with the product page and cart page ---------- */
  function toastFixed(text) {
    var t = document.createElement('div');
    t.className = 'lmxqa-toast lmxqa-toast--fixed';
    t.innerHTML = '<i>✓</i>' + esc(text || 'Added to cart');
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 1900);
  }
  window.LMXQA = {
    money: money, esc: esc, img: img, fly: fly, setBadge: setBadge,
    renderRail: renderRail, closeRail: closeRail, announce: announce,
    getCart: getCart, toast: toastFixed
  };

  /* ---------- product page: same button, stepper and animation ---------- */
  var onPDP = /\/products\/[^/]+/.test(location.pathname);
  var pdp = { product: null, last: null, busy: false };

  function pdpForm() {
    return document.querySelector('.product-information form[action*="/cart/add"]') ||
      document.querySelector('form.shopify-product-form[action*="/cart/add"]');
  }
  function pdpVariant() {
    var f = pdpForm(), i = f && f.querySelector('input[name="id"]');
    if (!i || !pdp.product) return null;
    var id = +i.value;
    return pdp.product.variants.filter(function (v) { return v.id === id; })[0] || null;
  }
  function pdpQtyInput() {
    var f = pdpForm();
    return (f && f.querySelector('input[name="quantity"]')) ||
      document.querySelector('.product-information quantity-selector-component input[name="quantity"]');
  }
  function pdpQty() {
    var q = pdpQtyInput();
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }
  function pdpSetQty(n) {
    var q = pdpQtyInput();
    if (!q) return;
    q.value = n;
    try { q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }
  function pdpLabel() {
    var v = pdpVariant(), qty = pdpQty();
    document.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      if (b.closest('.lmxqa-ov')) return;
      var off = !v || !v.available || b.disabled || b.getAttribute('aria-disabled') === 'true';
      if (off) { b.removeAttribute('data-lmxqa-label'); return; }
      var txt = v.compare_at_price && v.compare_at_price > v.price
        ? money((v.compare_at_price - v.price) * qty) + ' OFF! ADD NOW!'
        : 'Add to cart · ' + money(v.price * qty);
      if (pdp.busy) txt = 'Adding…';
      if (b.getAttribute('data-lmxqa-label') !== txt) b.setAttribute('data-lmxqa-label', txt);
    });
  }
  function pdpGalleryImg() {
    var best = null, area = 0;
    document.querySelectorAll('.product-information media-gallery img, .product-information slideshow-slide img').forEach(function (im) {
      var r = im.getBoundingClientRect();
      var w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
      var h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      if (w * h > area) { area = w * h; best = im; }
    });
    return best || document.querySelector('.add-to-cart-button');
  }
  function pdpStepper(show) {
    var comp = document.querySelector('.product-information add-to-cart-component');
    var st = document.querySelector('.lmxqa-pdp-step');
    if (!show) {
      if (st) st.remove();
      if (comp) comp.style.display = '';
      return;
    }
    if (!comp) return;
    if (!st) {
      st = document.createElement('div');
      st.className = 'lmxqa-added is-on lmxqa-pdp-step';
      st.setAttribute('aria-live', 'polite');
      st.innerHTML = '<button type="button" data-pl="-1" aria-label="Remove one">' + MINUS_SVG + '</button><div><b></b><small></small></div><button type="button" data-pl="1" aria-label="Add one">' + PLUS_SVG + '</button>';
      comp.parentNode.insertBefore(st, comp.nextSibling);
    }
    st.querySelector('b').textContent = pdp.last.qty + ' Added';
    st.querySelector('small').textContent = pdp.last.title || '';
    comp.style.display = 'none';
  }
  function pdpMsg(text, warn) {
    var old = document.querySelector('.lmxqa-pdp-err');
    if (old) old.remove();
    if (!text) return;
    var comp = document.querySelector('.lmxqa-pdp-step') || document.querySelector('.product-information add-to-cart-component');
    if (!comp) return;
    var p = document.createElement('p');
    p.className = 'lmxqa-err lmxqa-pdp-err' + (warn ? ' is-warn' : '');
    p.textContent = text;
    comp.parentNode.insertBefore(p, comp.nextSibling);
  }
  function pdpAfter(cart, key) {
    cartNow = cart;
    setBadge(cart.item_count);
    renderRail(cart, key);
    announce(cart);
  }
  function pdpAdd() {
    var v = pdpVariant();
    if (!v || !v.available || pdp.busy) return;
    pdpMsg('');
    var qty = pdpQty(), room = roomFor(pdp.stock, v.id), s = stockOf(pdp.stock, v.id), capped = false;
    if (room <= 0) { pdpMsg(stockNote(s, inCart(v.id), 'full'), true); return; }
    if (qty > room) { qty = room; capped = true; pdpSetQty(room); }
    pdp.busy = true; pdpLabel();
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        var item = (res.items && res.items[0]) || res;
        pdp.last = { id: v.id, key: item.key, qty: item.quantity, title: v.title === 'Default Title' ? '' : v.title };
        fly(pdpGalleryImg());
        toastFixed('Added to cart');
        pdpStepper(true);
        if (capped) pdpMsg('Only ' + s + ' left in stock, so we added the maximum you can (' + qty + ').', true);
        return getCart().then(function (cart) { pdpAfter(cart, item.key); });
      })
      .catch(function (e) { pdpMsg((e && (e.description || e.message)) || 'Could not add to cart. Please try again.'); })
      .then(function () { pdp.busy = false; pdpLabel(); });
  }
  function pdpChange(delta) {
    if (!pdp.last || pdp.busy) return;
    pdpMsg('');
    var s = stockOf(pdp.stock, pdp.last.id);
    if (delta > 0 && s != null && pdp.last.qty >= s) {
      pdpMsg('Only ' + s + ' left in stock — you already have all of them in your cart.', true);
      return;
    }
    pdp.busy = true;
    var next = Math.max(0, pdp.last.qty + delta);
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: pdp.last.key, quantity: next })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) {
        cartNow = cart;
        var line = cart.items.filter(function (it) { return it.key === pdp.last.key; })[0];
        pdp.last.qty = line ? line.quantity : 0;
        if (pdp.last.qty > 0) pdpStepper(true);
        else { pdp.last = null; pdpStepper(false); }
        pdpAfter(cart, line && line.key);
      })
      .catch(function (e) { pdpMsg((e && (e.description || e.message)) || 'Could not update the cart.'); })
      .then(function () { pdp.busy = false; pdpLabel(); });
  }

  if (onPDP) {
    var h0 = handleFrom(location.pathname);
    if (h0) fetch('/products/' + encodeURIComponent(h0) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { pdp.product = p; pdpLabel(); })
      .catch(function () {});
    getCart().then(function (c) { if (!cartNow) cartNow = c; }).catch(function () {});
    if (h0) stockFor(h0).then(function (m) { pdp.stock = m; });
    document.addEventListener('cart:update', function (e) {
      var c = e.detail && e.detail.resource;
      if (!c || !c.items) return;
      cartNow = c;
      /* removed from the panel: drop or update the stepper */
      if (pdp.last && !pdp.busy) {
        var ln = c.items.filter(function (it) { return it.key === pdp.last.key; })[0];
        if (!ln) { pdp.last = null; pdpStepper(false); }
        else if (ln.quantity !== pdp.last.qty) { pdp.last.qty = ln.quantity; pdpStepper(true); }
      }
    });

    /* take over Horizon's add to cart (click and form submit), capture phase */
    window.addEventListener('click', function (e) {
      /* quantity +: stop at what is left in stock */
      var plus = e.target.closest && e.target.closest('.product-information .quantity-plus');
      if (plus) {
        var pv = pdpVariant(), room = pv ? roomFor(pdp.stock, pv.id) : Infinity;
        if (room !== Infinity && pdpQty() + 1 > room) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          if (pdpQty() > Math.max(1, room)) pdpSetQty(Math.max(1, room));
          pdpMsg(stockNote(stockOf(pdp.stock, pv.id), inCart(pv.id), room <= 0 ? 'full' : 'capped'), true);
        }
        return;
      }
      var b = e.target.closest && e.target.closest('.add-to-cart-button');
      if (b && !b.closest('.lmxqa-ov') && pdp.product) {
        if (b.disabled || b.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        pdpAdd();
        return;
      }
      var s = e.target.closest && e.target.closest('.lmxqa-pdp-step [data-pl]');
      if (s) { e.preventDefault(); pdpChange(+s.getAttribute('data-pl')); }
    }, true);
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.id === 'lmxf-newsletter' || !pdp.product) return;
      if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      pdpAdd();
    }, true);

    /* keep label and stepper in step with the variant picker and quantity */
    setInterval(function () {
      if (!pdp.product) return;
      var v = pdpVariant();
      if (pdp.last && (!v || v.id !== pdp.last.id)) { pdp.last = null; pdpStepper(false); pdpMsg(''); }
      /* a typed or carried-over quantity above the stock comes back to the maximum */
      if (v && pdp.stock && !pdp.busy) {
        var room = roomFor(pdp.stock, v.id), qi = pdpQtyInput();
        if (qi && room !== Infinity) {
          if (qi.hasAttribute('max')) qi.removeAttribute('max');   /* Horizon subtracts its own cart count from max */
          if (room >= 1 && pdpQty() > room && document.activeElement !== qi) {
            pdpSetQty(room);
            pdpMsg(stockNote(stockOf(pdp.stock, v.id), inCart(v.id), 'capped'), true);
          }
        }
      }
      /* the chosen variant is already in the cart: show its stepper */
      if (!pdp.last && !pdp.busy && v && cartNow) {
        var line = cartNow.items.filter(function (it) { return it.variant_id === v.id; })[0];
        if (line) {
          pdp.last = { id: v.id, key: line.key, qty: line.quantity, title: v.title === 'Default Title' ? '' : v.title };
          pdpStepper(true);
        }
      }
      pdpLabel();
    }, 400);
  }

  /* cards are also built by JS (category pages, infinite scroll, related) */
  function boot() {
    decorate();
    restoreRail();
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
